import React from 'react';
import './styles.css';
import * as moment from 'moment';
import { mascaraCpf } from '../../modulos/mascaraCpf/index';

export const inscricaoBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Inscrição</span>
        {rowData.Inscricao}
    </React.Fragment>
);

export const nomeBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Nome</span>
        {rowData.Nome}
    </React.Fragment>
);

export const dataBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Data</span>
        {moment(rowData.Data)
            .add(3, 'hours')
            .format('DD/MM/YYYY')}
    </React.Fragment>
);

export const dataAceiteBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Data Aceite</span>
        {rowData.DataAceite ?
            moment(rowData.DataAceite)
                .add(3, 'hours')
                .format('DD/MM/YYYY') :
            'Não identificado'}
    </React.Fragment>
);

export const dataPagamentoBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Data Pagamento</span>
        {rowData.DataPagamento}
    </React.Fragment>
);

export const CPFBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">CPF</span>
        {mascaraCpf(rowData.CPF)}
    </React.Fragment>
);

export const vendedorBody = rowData => (
    <React.Fragment>
        <span className="p-column-title">Vendedor</span>
        {rowData.Vendedore && rowData.Vendedore.Nome}
    </React.Fragment>
);
